export default "__VITE_ASSET__toi$tKGm__"